<template>
  <div class="featureDetailBanner">
    <img
      class="d-block img-fluid w-100"
      width="1024"
      height="490"
      v-if="featureInfo.featureImgUrl && featureInfo.featureImgUrl.length>0"
      :src="featureInfo.featureImgUrl"
      alt
    />
  </div>
</template>

<script>
export default {
  name: "DetailBanner",
  props:['featureInfo']
};
</script>

<style>
</style>